<template>
  <dialogC v-if="show" :show="show" @close="$emit('close')" label="新增不分潤商品" :width="630">
    <div v-if="show" :style="{padding: '20px 40px'}">
      <div class="diagbox">
        <div class="infoCol infoColEdit">
          <div>品項</div>
          <div>{{item.name}}</div>
        </div>
        <div class="infoCol infoColEdit">
          <div>貨編</div>
          <div>{{item.id}}</div>
        </div>
        <div class="infoCol infoColEdit">
          <div>類別</div>
          <div><select v-model="item.type">
            <option value="noprofit">二消商品</option>
            <option value="ticket">門票</option>
          </select></div>
        </div>
        <div class="infoCol infoColEdit">
          <div>區域組別</div>
          <div class="group-checkbox">
            <input type="checkbox" v-model="item.area" value="吧檯">
            <input type="checkbox" v-model="item.area" value="松柏軒">
            <input type="checkbox" v-model="item.area" value="植栽">
            <input type="checkbox" v-model="item.area" value="票務">
            <input type="checkbox" v-model="item.area" value="內部用品">
          </div>
        </div>
        <div class="btns"><button class="cancel" @click="$emit('close')">取消</button><button class="confirm" @click="save">確認</button></div>
      </div>
    </div>
  </dialogC>
</template>

<script>
import dialogC from '../../components/dialognoPadding2.vue'
import { postapi } from '../../store/fetch'
export default {
  name: 'editProduct',
  components: {
    dialogC
  },
  data () {
    return {
      users: [],
      rolesmap: [],
      countries: [],
      disabledDates: [],
      area: [],
      item: {
        name: null,
        id: null,
        price: null,
        type: 'noprofit'
      },
      fieldsDetial: [
        '參觀日期',
        '參觀時段',
        '預約人',
        '旅行社',
        '統一編號',
        '領隊電話',
        '領隊',
        '團體名稱'
      ],
      fieldsDetial2: [
        '預約人數',
        '導覽需求',
        '票種',
        '總金額',
        '匯款預付'
      ]
    }
  },
  created () {
    this.item.type = this.product.type
    this.item.name = this.product.name
    this.item.id = this.product.id
    this.item.price = this.product.price
    this.item.area = this.product.area
  },
  props: ['show', 'product'],
  methods: {
    async save () {
      const item = { ...this.item }
      const r = await postapi(`products/${this.product._id}`, item)
      if (r) {
        this.$emit('updateProduct', r)
      }
    }
  }
}
</script>
<style>
.dialogbox > div:not(.headerBox) > div {
  margin-inline: 0!important;
  padding-inline: 0!important;
}</style>
<style lang="scss" scoped>
.diagbox {
  display: flex;
  flex-direction: column;
  gap: 33px;
}
.group-checkbox {
  display: flex;
  align-items:flex-start;
  flex-wrap: wrap;
  padding-left: 20px;
}
input[type=checkbox] {
  box-sizing: border-box;
  min-width: 176px;
  height: 49px;
  padding: 9.5px 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  appearance: none;
  gap: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.1em;
  color: #848484;
  &::before {
    content: '';
    display: inline;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    border: 1px solid var(--color-checked);
  }
  &:checked::before {
    content: '';
    background-image: url(/svg/checkbox/checkmark.svg);
    background-color: var(--color-checked);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 23px;
  }
  &::after {
    content: attr(value);
  }
}
textarea {
  width: 100%;
  height: 100%;
  min-height: 90px;
  border: none;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  &::placeholder {
    color: #999999;
  }
}
.btns {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  margin-top: 25px;
  button {
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    border: none;
  }
  .cancel {
    background-color: #B8B8B8;
  }
  .confirm {
    background-color: #E37878;
  }
}
.remark {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  text-align: start;
  color: var(--color-letter);
}
.hrdeco {
  height: 12px;
  background-color: transparent;
  width: 100%;
  background-image: url(/hrdeco.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: none;
}
.infofoot {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #999999;
}
.footCol {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  text-align: end;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  height: 32px;
}
.infoCol {
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 29px;
  text-align: center;
  letter-spacing: 0.1em;
  color: var(--color-letter);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  gap: 10px;
  height: fit-content;
  &:nth-child(1) {
    margin-top: 0;
  }
  input {
    text-align: center;
  }
}
</style>
<style lang="scss" scoped>
.infoColEdit {
  box-sizing: border-box;
  &>div:nth-child(1) {
    color: var(--color-checked);
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.1em;
  }
  &>:nth-child(2)>input[type=text], &>:nth-child(2)>select {
    height: 40px;
    box-sizing: border-box;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-checked);
    text-indent: 14px;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    box-sizing: border-box;
    text-align: center;
  }
  &>:nth-child(2)>input[type=text] {
    color: var(--color-letter);
  }
  &>:nth-child(2)>select {
    color: var(--color-checked);
    font-weight: bold;
  }
  &:nth-child(1)>:nth-child(2)>input[type=text], &:nth-child(1)>:nth-child(2)>select { width: 405px; }
  &:nth-child(2)>:nth-child(2)>input[type=text], &:nth-child(2)>:nth-child(2)>select { width: 300px; }
  &:nth-child(3)>:nth-child(2)>input[type=text], &:nth-child(3)>:nth-child(2)>select { width: 240px; }
  &:nth-child(4)>:nth-child(2)>input[type=text], &:nth-child(4)>:nth-child(2)>select { width: 240px; color: #E37878; font-weight: bold; }
}
</style>
